


(function () {

  // 👉 Esegui SOLO sulla pagina /search
  if (!window.location.pathname.startsWith("/search")) return;

  // 🔤 Dizionario EN → IT (aggiungi ciò che ti serve)
  var translations = {
  
     "Product Filters": "Filtri prodotto",
     "Products": "Prodotti",
     "Check the spelling or use a different word or phrase": "Controlla l'ortografia o usa una parola o una frase diversa",
    "Sort By:": "Ordina per:",
    "Sort By": "Ordina per",
    "Trending Products": "Prodotti di tendenza",
    "Trending": "Di tendenza",
    "Popular Products": "Prodotti popolari",
    "Featured": "In evidenza",
    "Best Sellers": "Più venduti",
    "Newest": "Più recenti",
    "Price: Low to High": "Prezzo: dal più basso",
    "Price: High to Low": "Prezzo: dal più alto",
    "Apply Filters": "Applica filtri",
    "Clear Filters": "Pulisci filtri",
    "Clear Filter": "Pulisci filtro",
    "Remove Filter": "Rimuovi filtro",
    "Results for": "Risultati per",
    "products": "prodotti",
    "product": "prodotto",
    "No results found": "Nessun risultato trovato",
    "Search results": "Risultati di ricerca",
    "Add to cart": "Aggiungi al carrello",
    "Load more": "Carica altri",
     "SEE MORE": "Mostra altri",
    "Previous": "Precedente",
    "Next": "Successivo",
     "Filters": "Filtri"
  };

  // 🔍 Applica le traduzioni a un nodo testuale
  function translateTextNode(node) {
    if (node.nodeType !== Node.TEXT_NODE) return;
    var text = node.nodeValue;
    if (!text) return;

    Object.keys(translations).forEach(function (key) {
      var regex = new RegExp("\\b" + key.replace(/[.*+?^${}()|[\]\\]/g, "\\$&") + "\\b", "g");
      text = text.replace(regex, translations[key]);
    });

    node.nodeValue = text;
  }

  // 🔁 Traduci tutto dentro gli elementi Rebuy
  function translateRebuy() {
    var containers = document.querySelectorAll(
      '.rebuy, [class*="rebuy"], [data-rebuy-id]'
    );

    containers.forEach(function (container) {
      var walker = document.createTreeWalker(
        container,
        NodeFilter.SHOW_TEXT,
        null,
        false
      );
      var node;
      while ((node = walker.nextNode())) {
        translateTextNode(node);
      }
    });
  }

  // 1️⃣ Al caricamento della pagina
  document.addEventListener("DOMContentLoaded", translateRebuy);

  // 2️⃣ Ripetizione (per contenuti Rebuy caricati dopo)
  var tries = 0;
  var interval = setInterval(function () {
    translateRebuy();
    tries++;
    if (tries > 20) clearInterval(interval);
  }, 500);

  // 3️⃣ Ascolta cambiamenti dinamici nel DOM (AJAX Rebuy)
  if ("MutationObserver" in window) {
    var observer = new MutationObserver(function () {
      translateRebuy();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

})();

